import Carousel from "./components/carousel";
import Login from "./components/login";
import Otp from "./components/otp";
import Estampform from "./components/estampform";
import ESignWidgetComponent from "./components/esignwidget";
import Complete from "./components/complete";
import Error from "./components/error";
import logo from "../src/image/logo-orignal.png";
import { useState } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Failed from "./components/failed";
import Approved from "./components/approved";
import Ddpipayment from "./components/ddpipayment";
import Paymentstatus from "./components/paymentStatus";

function App() {
  const [Clientnum, setClientnum] = useState("");
  const [ClientUid, setClientUid] = useState("");
  const [ouid, setouid] = useState("");

  function logindata(loginnum) {
    setClientnum(loginnum);
  }
  function uniqueid(UID) {
    setClientUid(UID);
  }
  function otpid(Ouid) {
    setouid(Ouid);
  }
  // console.log("Test", window.location.pathname);

  // const [path,setpath] = useState(window.location.pathname);
  // useEffect(()=>{
  //   setpath(window.location.pathname);
  // })
  return (
    <>
      <div className="App">
        <div className="container-wrap">
          <div className="logo-img">
            <img src={logo}></img>
          </div>
          {/* {path == "/faq" || path=="*" ? (
          <div className="desktop-carousel hidden">
            <Carousel />
          </div>
        ) : (
          <div className="desktop-carousel">
            <Carousel />
          </div>
        )} */}
          <div className="desktop-carousel">
            <Carousel />
          </div>

          <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={
                  <Login passclientcode={logindata} passuniqueId={uniqueid} />
                }
              ></Route>
              <Route
                path="/otp"
                element={
                  <Otp
                    clientnumsend={Clientnum}
                    clientIdsend={ClientUid}
                    passotpuniqueId={otpid}
                  />
                }
              ></Route>
              <Route path="/preview" element={<Ddpipayment/>}></Route>
              <Route path="/paymentstatus" element={<Paymentstatus/>}></Route>
              <Route path="/estampform" element={<Estampform />}></Route>
              <Route path="/esign" element={<ESignWidgetComponent />}></Route>
              <Route path="/failed" element={<Failed />}></Route>
              <Route path="/complete" element={<Complete />}></Route>
              <Route path="/approved" element={<Approved/>}></Route>
              <Route path="*" element={<Error />}></Route>
            </Routes>
          </BrowserRouter>
        </div>
      </div>
    </>
  );
}

export default App;
